module.exports = __webpack_public_path__ + "static/img/2652_phase_function_Paper_PointsHejduk_Prediction.5a2a910.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2652_phase_function_Paper_PointsHejduk_Prediction.png
// module id = kUVf
// module chunks = 0